module.exports = __webpack_public_path__ + "components/breakheader/background/background--4-d503c1fbd7911cc6f64ed6b131058cc1.jpg";